module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gQpg3"))).then(() => parcelRequire('hEqeo'));